import headerbg from "../../assets/images/headerbg.png";
import headerbgmobile from "../../assets/images/headerbgmobile.png";
import applynowbtn from "../../assets/images/applynowbtn2.png";

import { LazyLoadImage } from "react-lazy-load-image-component";

const Header = () => {
  return (
    <section className="w-full flex justify-center relative">
      <LazyLoadImage
        className="w-full"
        src={window.innerWidth < 768 ? headerbgmobile : headerbg}
        alt="mt&staj programları zirvesi"
      />
      <div className="absolute bottom-[35px] md:bottom-[65px] lg:bottom-[80px] xl:bottom-[117px]">
        <a href="#kayit-ol">
          <img
            loading="lazy"
            className="w-[120px] md:w-[250px] lg:w-[300px] xl:w-[369px]"
            src={applynowbtn}
            alt="applynowbtn"
          />
        </a>
      </div>
    </section>
  );
};

export default Header;
